const Menu = [
  {
    path: "/",
    icon: "fa fa-th",
    title: "Inicio",
  },
  {
    path: "/fiscalizacion",
    icon: "fas fa-file-alt",
    title: "Fiscalización",
  },
  {
    path: "/Visitas",
    icon: "fas fa-clipboard-check",
    title: "Visitas",
  },
  {
    path: "/Metas",
    icon: "fa fa-flag-checkered",
    title: "Metas",
  },
  {
    path: "/descargar-app",
    icon: "fas fa-mobile-alt",
    title: " Descargar aplicación móvil",
  },
];

export default Menu;
